import React from 'react'
import { Backdrop, styled } from '@mui/material'
import { Loader } from 'packages/eid-ui'

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(0.8rem)',
}))

const FullScreenLoader = () => {
    return (
        <StyledBackdrop open={true}>
            <Loader />
        </StyledBackdrop>
    )
}

export default FullScreenLoader
